import { HelpersService } from './../../services/tools/helpers.service';
import { InversionistasGruposService } from './../../services/inversionistas-grupos.service';
import { InversionistasService } from './../../services/inversionistas.service';
import { ValidatorService } from '../../services/tools/validator.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../tools/modals/confirm-modal/confirm-modal.component';
import {Globals} from './../../services/tools/Globals.service';
declare let $;

@Component({
  selector: 'app-catalogo-inversionistas-grupos',
  templateUrl: './catalogo-inversionistas-grupos.component.html',
  styleUrls: ['./catalogo-inversionistas-grupos.component.scss']
})
export class CatalogoInversionistasGruposComponent implements OnInit {

  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;

  inversionistasGrupos: any[];
  inversionistasList: any[];
  searchText: string = '';
  inversionistasGrupoSelected: any;
  inversionistasSelected: any[];
  inversionistaToAdd: any;
  mostrarListado: boolean = true;
  errors: any = {};
  searchProcess: any;
  paginate: any = {};
  filterByInversionista:any;
  currentPage: any = 1;
  lastPage: any = 1;
  processing: any = false;
  alterTable:any = 'starting';
  exporting: any = false;

  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;

  constructor ( private inversionistasService: InversionistasService,
                private inversionistasGruposService: InversionistasGruposService,
                private validatorService: ValidatorService,
                private helperService: HelpersService,
                private globals: Globals) {

    // se colocó esto para que el this dentro de delete sea el del scope global
    this.deleteInversionistasGrupo = this.deleteInversionistasGrupo.bind(this);
    this.resetInversionistasGrupoSelected = this.resetInversionistasGrupoSelected.bind(this);
    this.getInversionistasGrupos();
    this.getInversionistas();
   }

  ngOnInit() {
    this.globals.passwordActivate = false;
  }

  pageChanged(event: any): void {
    if(event.page !== undefined)
      if(event.page != this.page)
      {  
        this.page = event.page;
      }
    this.goPage(this.page);
  }

  filtrarInversionistasGrupos() {
    this.goPage(1);

  }

  resetInversionistasGrupoSelected() {
    this.inversionistasGrupoSelected = undefined;
    this.inversionistasSelected = [];
    this.inversionistaToAdd = undefined;
    this.errors = {};
  }

  startInversionistasGrupoSelected() {
    this.resetInversionistasGrupoSelected();
    this.inversionistasGrupoSelected = this.inversionistasGruposService.getDefaultSchedule();
    this.inversionistaToAdd = undefined;
    this.inversionistasSelected = [];
  }

  selectInversionistaGrupos(inversionistasGrupo) {
    this.resetInversionistasGrupoSelected();
    const inversionistasGrupoCloned = JSON.parse(JSON.stringify( inversionistasGrupo ));
    this.inversionistasGrupoSelected = inversionistasGrupoCloned;
    const inversionistas_elementos_cloned = JSON.parse(JSON.stringify( inversionistasGrupo.inversionistas_elementos ));
    this.inversionistasSelected = inversionistas_elementos_cloned;
  }

  SelectedInversionistasGruposClass(inversionista) {
    return (this.validatorService.required(this.inversionistasGrupoSelected) &&  this.inversionistasGrupoSelected.idInversionistas_Grupos === inversionista.idInversionistas_Grupos) ? 'active' : '';
  }

  searchInversionistasGrupos(page = null) {
    if (this.searchProcess) {
      this.searchProcess.unsubscribe();
    }

    if (this.searchText.length > 1) {
      this.searchProcess = this.inversionistasGruposService.searchInversionistasGrupos(this.searchText, page)
          .subscribe(response => {
            const content = response.json().content;
            this.inversionistasGrupos = content.data;
            this.startPaginate(content);
            this.searchProcess = false;
            this.alterTable = (this.inversionistasGrupos.length > 0)? false: 'not_found';
          });
    } else {
      this.getInversionistasGrupos();
    }
  }

  getInversionistas(page = null) {

    this.inversionistasService.getInversionistasList()
      .subscribe(response => {
        this.inversionistasList = response.json().content.inversionistas;
      }, error => {
        // resoliendo errores 403 y 500
        this.helperService.httpGlobalError(error, false);
      });
  }

  getInversionistasGrupos(page = null) {

    this.searchProcess = this.inversionistasGruposService.getInversionistasGrupos(page)
      .subscribe(response => {
        const content = response.json().content;

        console.log('content ', content);

        this.inversionistasGrupos = content.data;
        this.startPaginate(content);
        this.alterTable = (this.inversionistasGrupos.length > 0)? false: 'not_result';
        this.searchProcess = false;
      }, error => {
        this.searchProcess = false;
        // resoliendo errores 403 y 500
        this.helperService.httpGlobalError(error);
      });
  }
  createInversionistasGrupo() {
    this.errors = [];

    this.inversionistasGrupoSelected.inversionistas_elementos = this.inversionistasSelected;
    this.errors = this.inversionistasGruposService.validateInversionistaGrupo(this.inversionistasGrupoSelected);
    if (!$.isEmptyObject(this.errors)) {
      return false;
    }

    this.processing = true;
    this.inversionistasGruposService.createInversionistasGrupo(this.inversionistasGrupoSelected)
      .subscribe(response => {
        const respuesta = response.json();
        this.processing = false;
        if (respuesta.success) {
          this.successModal.open({
            'title': '¡Éxito!',
            'description': 'Se ha creado correctamente el grupo'
          });
          this.inversionistasGrupoSelected.idInversionistas_Grupos = respuesta.content.id;
          this.goPage(1);
        } 
      }, error => {
        this.processing = false;
        // resoliendo errores 403 y 500
        this.helperService.httpGlobalError(error, false);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
        }

        if (error.status == 403 || error.status == 500) {
          this.errorModal.open({
            'title': 'Error!',
            'description': 'No se ha podido guardar el grupo, inténtelo más tarde'
          });
        }
      });
  }

  updateInversionistasGrupo() {
    this.errors = [];
    this.inversionistasGrupoSelected.inversionistas_elementos = this.inversionistasSelected;
    this.errors = this.inversionistasGruposService.validateInversionistaGrupo(this.inversionistasGrupoSelected);
    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    this.processing = true;
    this.inversionistasGruposService.updateInversionistasGrupo(this.inversionistasGrupoSelected, this.inversionistasGrupoSelected.idInversionistas_Grupos)
      .subscribe(response => {
        this.processing = false;
        if (response.json().success) {
          this.helperService.notification('¡Éxito!', 'Se ha editado correctamente el grupo', 'success');
          this.goPage(this.currentPage);
        } else {
          
          this.errorModal.open({
            'title': 'Error!',
            'description': 'No se ha podido guardar el grupo, inténtelo más tarde'
          });
        }
      }, error => {
        this.processing = false;
        // resoliendo errores 403 y 500
        this.helperService.httpGlobalError(error);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde', 'error');
        }
      });
  }

  writePermission() {
    return this.inversionistasGruposService.writePermission();
  }

  canExport() {
    return this.inversionistasGruposService.canExport();
  }

  export() {
    this.exporting = true;
    this.inversionistasGruposService.export(this.searchText)
      .subscribe((response) => {
        this.exporting = false;
      }, error => {
        // se resuelven los errores 403 y 500
        this.exporting = false;
        this.helperService.httpGlobalError(error);
      });
  }

  confirmDeleteInversionistasGrupo() {
    this.confirmModal.open({
      'title': 'Eliminar obra',
      'description': '¿Está seguro que desea eliminar este Grupo?',
      'callback': this.deleteInversionistasGrupo
    });
  }

  deleteInversionistasGrupo() {
    this.processing = true;
    this.inversionistasGruposService.deleteInversionistasGrupo(this.inversionistasGrupoSelected.idInversionistas_Grupos)
      .subscribe(
        response => {
          const respuesta = response.json();
          this.processing = false;
          if (respuesta.success) {
            this.successModal.open({
              'title': '¡Éxito!',
              'description': 'Se ha eliminado correctamente el grupo seleccionado'
            });
            this.resetInversionistasGrupoSelected();
            this.goPage(this.currentPage);
          }          
      }, error => {
          this.processing = false;
          // resoliendo errores 403 y 500
          this.helperService.httpGlobalError(error, false);

          if (error.status == 400) {
            this.errorModal.open({
              'title': 'Error',
              'description': error.json().content.group_exist
            });  
          } else if (error.status == 500) {
            this.errorModal.open({
              'title': 'Error',
              'description': 'Ha ocurrido un error al intentar eliminar el grupo, inténtelo más tarde'
            });
          }
      });
  }

  addInversionista() {
    this.inversionistasSelected.push({
      'inversionistas': this.inversionistaToAdd
    });
    this.inversionistaToAdd = '';
  }

  removeInversionista(index) {
    this.inversionistasSelected.splice(index,1);
  }

  disabledAddInversionista() {
    const _this = this;

    if (!this.validatorService.required(this.inversionistaToAdd)) {
      return true;
    }

    const found = this.inversionistasSelected.find(function(element) {
      return element.inversionistas.idInversionistas === _this.inversionistaToAdd.idInversionistas;
    });

    if (found) {
      return true;
    }

    return false;
  }

  setBackendErrors(errors: any[]) {
    const temp_errors = [];
    Object.keys(errors).forEach(function(key) {
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  inversionistasGrupoSelectedWithId() {
    if (! this.inversionistasGrupoSelected) {
      return false;
    }

    return (this.validatorService.required(this.inversionistasGrupoSelected.idInversionistas_Grupos));
  }

  cancelarInversionistasGrupoSelected() {
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetInversionistasGrupoSelected
    });
  }

  getIntegrantesLista(list) {

    let nombres = '';
    const _this = this;

    list.forEach(function(element, key) {
      if (key > 0) {
        nombres = nombres + ', ';
      }

      nombres = nombres + element.inversionistas.nombre;

    });

    return nombres;

  }

  // MODAL FUNCTIONS

  modalCallback(callback) {
    callback();
  }

  mainContainerClass() {
    return (this.mostrarListado) ? 'col-12' : 'offset-2 col-8';
  }

  mainTableClass() {
    return (this.mostrarListado) ? 'col-8' : 'col-4';
  }

  mainDetailsClass() {
    return (this.mostrarListado) ? 'col-4' : 'col-8';
  }

  startPaginate(content) {
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for (let i = 1; i <= this.paginate.last_page; i++) {
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage() {
    this.goPage(this.paginate.current_page - 1);
  }

  goNextPage() {
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {

    if (this.searchText) {
      this.searchInversionistasGrupos(page);
    } else {
      this.getInversionistasGrupos(page);
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/components/catalogo-inversionistas-grupos/catalogo-inversionistas-grupos.component.ts